// // sub.jsファイルを読み込む
// import {hello} from "./sub";
// // sub.jsに定義されたJavaScriptを実行する
// hello();

// Javascript
// - node_modules
import $ from 'jquery';
// - original
import Common from './common';
import FrontPage from './FrontPage';
import ContactPage from './contactPage';

// Sass/css
// - from node_modules
import "animate.css";
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'normalize.css';
// - from original theme
import "../sass/style.scss";

$(function(){
   new Common();
   new FrontPage();
   new ContactPage();

   // // 事例（ギャラリー）ページの「一覧へ戻る」ボタン
   // document.getElementById('backToGalleryList').addEventListener('click', (event) => {
   //    event.preventDefault();
   //    if (document.referrer.startsWith("http://localhost/gallery/")) {
   //       window.history.back();
   //    } else {
   //       window.location.href = "http://localhost/gallery/";
   //    }
   // });
   // → phpファイルへ
});

